// "N Stempel noch nicht uebertragen" -- ab einer Schwelle wird's dringlicher, aber NIE
// wegklickbar (Architektur §2: "Die Verantwortung fuer einen haengenden Sync wird damit
// sichtbar gemacht statt versteckt").

const URGENT_THRESHOLD = 5

interface Props {
  pendingCount: number
}

export function PendingBanner({ pendingCount }: Props) {
  if (pendingCount === 0) return null

  const urgent = pendingCount >= URGENT_THRESHOLD

  return (
    <div className={`pending-banner${urgent ? ' urgent' : ''}`}>
      {pendingCount} Stempel noch nicht uebertragen
      {urgent ? ' — bitte Geraet ins Netz bringen' : ''}
    </div>
  )
}
